<template>
	<div>
		<div>
			<span class="font-weight-bold text-primary cursor-pointer" @click=showDetailOrders>
				{{ `#${data.order_id}` }}
			</span>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'OrderIdColumn',
	props: {
		data: {
			type: Object,
			default: () => ({}),
		},
	},
	data() {
		return {
			actions: [
				{
					title: 'Edit Order',
					icon: 'bi bi-pencil-fill',
					key: 'edit_order',
				},
			],
		};
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
		}),
	},
	methods: {
		showDetailOrders() {
			this.$emit('show-detail-orders', this.data);
		},
	},
};
</script>

<style lang="scss" scoped>
.btn-orderid {
	opacity: 0;
}
</style>
